import axios from 'axios';

export const AUTHENTICATE_URL = `${process.env.REACT_APP_API_URL}/Authenticate`;

const withBearerToken = (accessToken: string) => ({
  headers: { Authorization: `Bearer ${accessToken}` },
});

export const updateTwoFactorAuthentication = (enabled: boolean, accessToken: string) => {
  return axios.patch(`${AUTHENTICATE_URL}/update-2FA`, { enabled }, withBearerToken(accessToken));
};

export const setupAuthenticator = (accessToken: string) => {
  return axios.post(`${AUTHENTICATE_URL}/setup-authenticator`, undefined, withBearerToken(accessToken));
};

export const verify2FaCode = (code: string, accessToken: string) => {
  return axios.post(`${AUTHENTICATE_URL}/verity-2fa-code`, { code }, withBearerToken(accessToken));
};

export const resetPassword = (email: string, newPassword: string, confirmPassword: string, token: string, captchaToken: string | null) => {
  return axios.post(`${AUTHENTICATE_URL}/reset-password`, { email, newPassword, confirmPassword, token, captchaToken });
}
